export const notImplementedExports = [
  'app_insights_summary_show',
  'app_graph_show',
  'apps_about',
  'apps_demographics',
  'ad_intelligence/app_creatives_show',
  'app_sdks_show',
  'review_analysis/app_reviews_sentiments_show',
  'review_analysis/app_reviews_intents_show',
  'review_analysis/app_reviews_keywords_show',
  'publishers_show',
  'publishers_unified',
  'companies_show',
  'x_ray/app_x_ray_analysis_show',
  'ad_intelligence/app_creatives_show',
  // 'app_user_retention_unified',
];

export const pageNamesMapping = {
  apps_performance: 'New App Performance Export Request',
  rank_history_show: 'New App Rank History Export Request',
  apps_downloads_and_revenue: 'New App Downloads&Revenue Export Request',
  apps_engagement: 'New App Engagement Export Request',
  app_user_retention_show: 'New App User Retention Export Request',
  'search_analysis/app_searches_organic_keywords_show': 'New App ASO Export Request',
  'search_analysis/app_searches_paid_searches_show': 'New App ASO Export Request',
};
